/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { CalendarWorkdaysCalc, defaultWorkdays } from './CalendarWorkdaysCalc';
import { Role } from '@touchplan/common';
import { IObservableLike } from '../interfaces/IObservable';
import { standardizeObservable } from '../duck-type-utils/observable-duck';

export * from './CalendarWorkdaysCalc';

//not going to bother making this generic/ extensible, is a pretty simple/ specific thing
export class CalendarWorkdays extends CalendarWorkdaysCalc {
	// eslint-disable-next-line @typescript-eslint/typedef
	private shutdownSubject$ = new Subject<void>();

	public constructor(
		rolesList$: IObservableLike<Map<string, Role>>,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		projectWorkday$: IObservableLike<any>, //expects data of the project workdays form
		exceptionDayList$: IObservableLike<Map<string, boolean>>
	) {
		super();

		const wrappedRolesList$ = standardizeObservable(rolesList$);
		const wrappedProjectWorkday$ = standardizeObservable(projectWorkday$);
		const wrappedExceptionDayList$ = standardizeObservable(exceptionDayList$);

		wrappedProjectWorkday$.pipe(takeUntil(this.shutdownSubject$)).subscribe((workDays) => {
			if (!workDays || !workDays.length || workDays.every((d: number) => d === 0)) {
				// Logging.warning('No workdays set, default to every day being a workday');
				this.projectWorkdays = defaultWorkdays;
			} else {
				this.projectWorkdays = workDays;
			}
		});

		wrappedExceptionDayList$.pipe(takeUntil(this.shutdownSubject$)).subscribe((list) => {
			this.exceptionDays = list;
		});

		//could probably save some perf using rawEvent$
		wrappedRolesList$
			.pipe(
				map((roleList) => {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const dows: any = {};
					roleList.forEach((role, key) => {
						dows[key] = role.view.workShiftsByDow ? role.view.workShiftsByDow : null;
					});
					return dows;
				}),
				takeUntil(this.shutdownSubject$)
			)
			.subscribe((roleDows) => {
				this.roleDows = roleDows;
				// this.updateRowDows(roleDows);
			});
	}

	public destroy(): void {
		this.shutdownSubject$.next();
		this.shutdownSubject$.complete();
		super.destroy();
	}
}
